import React from "react";
import { Layout, Modal, Popover } from "antd";
import { Link } from "react-router-dom";

import { toggleCollapsedSideNav, userSignOut, setCurrency } from "../../appRedux/actions";
import UserInfo from "../../components/UserInfo";
import Auxiliary from "util/Auxiliary";
import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import { CisUI } from "../../util/CISUI";
import UserProfile from "../Sidebar/UserProfile";
import Shortcuts from "../../components/Shortcuts";

const { Header } = Layout;

const Topbar = () => {
  const { navStyle } = useSelector(({ settings }) => settings);
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const currentCurrency = useSelector(({ common }) => common.currency);
  const dispatch = useDispatch();
  const Logo = "/assets/images/penterpv1.png";

  const currencyOptions = [
    { symbol: "₵", name: "Ghanaian Cedi (GHC)" },
    { symbol: "$", name: "US Dollar (USD)" },
    { symbol: "£", name: "Pound (GBP)" },
    { symbol: "€", name: "Euro (EUR)" },
    { symbol: "C$", name: "Canadian Dollar (CAD)" },
    { symbol: "FCFA", name: "CFA Franc (XOF)" },
  ];

  const currencyMenu = (
    <div
      style={{
        background: "#fff",
        borderRadius: 8,
        padding: "6px 0",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        minWidth: 160,
      }}
    >
      {currencyOptions.map((c) => (
        <div
          key={c.symbol}
          onClick={() => dispatch(setCurrency(c.symbol))}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            background: currentCurrency === c.symbol ? "#e6f7ff" : "transparent",
            color: currentCurrency === c.symbol ? "#1890ff" : "#333",
            fontWeight: currentCurrency === c.symbol ? 600 : 400,
            fontSize: 14,
          }}
          onMouseEnter={(e) => {
            if (currentCurrency !== c.symbol) e.target.style.background = "#f5f5f5";
          }}
          onMouseLeave={(e) => {
            if (currentCurrency !== c.symbol) e.target.style.background = "transparent";
          }}
        >
          <span style={{ fontSize: 16 }}>{c.symbol}</span>
          <span>{c.name}</span>
        </div>
      ))}
    </div>
  );

  // const handleChange = (value) => {
  // }

  const showLogoutConfirm = () => {
    Modal.confirm({
      title: "Are you sure you want logout?",
      centered: true,
      onOk: () => dispatch(userSignOut()),
      okText: "Yes",
      cancelText: "No",
      // content: 'Bla bla ...',
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: "center" }}>
          {/*<CancelBtn />*/}
          <OkBtn />
        </div>
      ),
    });
  };

  return (
    <div>
      <Header style={{ background: "#2F4E67" }}>
        {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ? (
          <div className="gx-mr-3 gx-linebar">
            <i
              className="gx-icon-btn icon icon-menu"
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}
            />
          </div>
        ) : null}
        {width >= TAB_SIZE && (
          <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
            <img alt="" src={Logo} style={{ width: "50px" }} />
          </Link>
        )}

        <div style={{ fontWeight: "bold", fontSize: "20px" }}>{CisUI().getUserInfo("companyName")}</div>

        <ul className="gx-ml-auto gx-header-notifications">
          {width >= TAB_SIZE && (
            <li style={{ display: "flex", gap: "10px", color: "white" }}>
              <a href="https://support.penterp.com/" target="_blank">
                <i
                  className="icon icon-sweet-alert"
                  style={{
                    position: "relative",
                    top: "3px",
                    margin: "0px 5px 0px 0px",
                    fontSize: "15px",
                    color: "white",
                  }}
                />
                <span className="support-title" style={{ fontSize: "15px", color: "white" }}>
                  Help
                </span>
              </a>
            </li>
          )}

          <Auxiliary>
            <li className="gx-user-nav">
              <UserProfile />
            </li>
          </Auxiliary>
        </ul>
      </Header>
      <div
        style={{
          height: "35px",
          color: "white",
          background: "#487091",
          padding: "0 32px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        className="no-print"
      >
        <div style={{ display: "flex", columnGap: "18px", fontSize: "16px", marginTop: "6px" }}>
          <div>
            <ul className="gx-ml-auto gx-header-notifications">
              <li className="gx-msg">
                <Popover
                  overlayClassName="gx-popover-horizantal"
                  placement="bottomRight"
                  content={<Shortcuts />}
                  trigger="click"
                >
                  <span className="gx-d-block gx-pointer gx-status-pos">
                    <i className="icon icon-apps icon__color" /> Favorites
                  </span>
                </Popover>
              </li>

              <li>
                <li>
                  <Link to={"/changelayout"}>
                    <i className="icon icon-callout" style={{ color: "white" }}></i>
                  </Link>
                </li>
              </li>
              <li className="currency">
                <Popover content={currencyMenu} trigger="click" placement="bottomRight" style={{ width: "100%" }}>
                  <span style={{ cursor: "pointer", fontSize: 18, fontWeight: 600, color: "white" }}>
                    {currentCurrency}
                  </span>
                </Popover>
              </li>
              <li className="gx-language" onClick={showLogoutConfirm}>
                <button type="button" className="ant-btn ant-btn-danger" style={{ height: "40px", marginTop: "10px" }}>
                  <span>Logout</span>
                </button>
              </li>

              {width >= TAB_SIZE ? null : (
                <Auxiliary>
                  <li className="gx-user-nav">
                    <UserInfo />
                  </li>
                </Auxiliary>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
